import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { DEPARTMENT_TYPE_SENIOR } from 'src/app/core/constants';

@Component({
    selector: 'app-senior-attached',
    templateUrl: './senior-attached.component.html',
    styleUrls: ['./senior-attached.component.scss'],
})
export class SeniorAttachedComponent implements OnInit {
    /**
     * Definição da identificão da sessão/depto Senior
     */
    public departmentType: string = DEPARTMENT_TYPE_SENIOR;

    /**
     * Definição do parâmetro recebido via url através do menu sidebar
     */
    public sessionType;

    constructor(private route: ActivatedRoute) {
        this.route.params.subscribe((params) => (this.sessionType = params['sessionType']));
    }

    ngOnInit(): void {
        //console.log('sessionType=' + this.sessionType);
    }
}
